function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import ReactDatePicker from 'react-datepicker';
const MonthPicker = _ref => {
  let {
    selected,
    onChange,
    className,
    dateFormat,
    ...rest
  } = _ref;
  const transformDate = date => {
    if (!date) {
      return null;
    }
    const dateArray = date.split('/');
    if (dateArray.length === 3) {
      return new Date(`${dateArray[2]}-${dateArray[1]}`);
    } else if (dateArray.length === 2) {
      return new Date(`${dateArray[1]}-${dateArray[0]}`);
    }
  };
  const handleDateChange = (date, name) => {
    let formattedDate;
    if (date) {
      formattedDate = `${date.getMonth() + 1}/${date.getFullYear()}`;
    }
    onChange(formattedDate);
  };
  return /*#__PURE__*/React.createElement(ReactDatePicker, _extends({}, rest, {
    className: className || 'custom-datepicker-input form-control',
    selected: transformDate(selected),
    onChange: date => handleDateChange(date),
    dateFormat: dateFormat || "MM/yyyy",
    showMonthYearPicker: true
  }));
};
export default MonthPicker;